import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

interface Props {
  amount: number | string
  referenceDate: moment.Moment
}

const UsedUntilReferenceDate = ({ amount, referenceDate }: Props) => {
  return (
    <Box>
      <Box flexDirection="row" justifyContent="spaceBetween" textAlign="left">
        <Text.Normal color="grey000White">{i18n.t('time_off.available_tooltip.used')}</Text.Normal>
        <Text.Normal color="grey000White">{amount}</Text.Normal>
      </Box>
      {moment().startOf('day').diff(referenceDate.startOf('day')) == 0 && (
        <Box flexDirection="row" justifyContent="flexStart">
          <Text.Normal size="200" color="grey000White">
            {i18n.t('time_off.available_tooltip.until_today')}
          </Text.Normal>
        </Box>
      )}
    </Box>
  )
}

export default UsedUntilReferenceDate
